import { render, staticRenderFns } from "./RoundProoveScore.vue?vue&type=template&id=88b4b69a&scoped=true&"
import script from "./RoundProoveScore.vue?vue&type=script&lang=js&"
export * from "./RoundProoveScore.vue?vue&type=script&lang=js&"
import style0 from "./RoundProoveScore.vue?vue&type=style&index=0&id=88b4b69a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b4b69a",
  null
  
)

export default component.exports